
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";


import operatingpoint from './modules/OperatingPoint';
import productdata from './modules/ProductData';
import shoppingcart from './modules/ShoppingCart.js';
import user from './modules/user.js';
import globalData from './modules/globalData.js';
import projectData from './modules/projectData';
import validation from './modules/validation';
import alert from './modules/alert';




Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    modules: {
        operatingpoint,
        productdata,
        shoppingcart,
        user,
        globalData,
        projectData,
        validation,
        alert,

    }

});